
<!-- Copyright (c) 2023 Cigent Technology Inc. All Rights Reserved. -->
<ng-container *ngIf="user$ | async as user">
    <ng-container *ngIf="restConfig$ | async as restConfig">
        <mat-tab-group *ngIf="user.org_type.value === OrgType.CUSTOMER; else mspView">
            <mat-tab *ngIf="user.org_type.value === OrgType.CUSTOMER" label="{{'cryptography.tabs.file-decryption' | translate}}">
                <ng-template matTabContent>
                    <app-file-decryption></app-file-decryption>
                </ng-template>
            </mat-tab>
            <mat-tab *ngIf="encryptionEventViewer" label="{{'cryptography.tabs.encryption-events' | translate}}">
                <ng-template matTabContent>
                    <app-encryption-event-viewer></app-encryption-event-viewer>
                </ng-template>
            </mat-tab>
            <mat-tab *ngIf="user.org_type.value === OrgType.CUSTOMER && restConfig.key_import_enabled"
                     label="{{'cryptography.tabs.manage-keys' | translate}}">
                <ng-template matTabContent>
                    <app-manage-keys></app-manage-keys>
                </ng-template>
            </mat-tab>
        </mat-tab-group>
        <ng-template #mspView>
            <app-encryption-event-viewer></app-encryption-event-viewer>
        </ng-template>
    </ng-container>
</ng-container>
